import { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";
import { bodyTextRegular } from "./style";
import { LoopSectionName } from "./LoopSection";
import { breakpoint } from "./style";
import SampleSensorData from "../data/sample-data.json";
import Movement1 from "../img/movement-1.png";
import Movement2 from "../img/movement-2.png";
import Movement3 from "../img/movement-3.png";
import Movement4 from "../img/movement-4.png";
import Movement5 from "../img/movement-5.png";
import Movement6 from "../img/movement-6.png";

import Visualization1 from "../img/visualization/visualization-1.png";
import Visualization2 from "../img/visualization/visualization-2.png";
import Visualization3 from "../img/visualization/visualization-3.png";
import Visualization4 from "../img/visualization/visualization-4.png";
import Visualization5 from "../img/visualization/visualization-5.png";
import Visualization6 from "../img/visualization/visualization-6.png";
import Visualization7 from "../img/visualization/visualization-7.png";
import Visualization8 from "../img/visualization/visualization-8.png";

import Interpretation1 from "../img/interpretation-1.png";

import Sensors1 from "../img/sensors-1.png";
import MusicScoreSnippet from "../img/music-score.png";

const frameTimeStep = 500;

const aspectRatio = 1920 / 1080; // height / width

const SectionContainer = styled.div`
    display: flex;
    width: 100%;
    flex-direction: row;
    margin: 100px 0px;
    padding: 0px 50px;
    align-items: flex-start;
    position: relative;

    @media ${breakpoint.laptop} {
        flex-direction: column;
        margin-bottom: 150px;
    }

    @media ${breakpoint.phone} {

        padding: 0px 40px;

    }

`;

const ImageOuterContainer = styled.div`
    flex: 0 1 60%;
    width: 60%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @media ${breakpoint.laptop} {
        width: 100%;
    }

`;

const ImageInnerContainer = styled.div`
    width: 100%;
    position: relative;
    aspect-ratio: ${aspectRatio};
    // background: black;
    border-radius: 5px;

    &.bg-white {
        background: white;
    }

    
    &.freestanding {
        aspect-ratio: unset;
        height: fit-content;
        background: none;
    }

`;

const TextContainer = styled.div`
    width: 40%;

    ${bodyTextRegular}

    & p {
        margin: 0px 0px 0px 40px;
        font-size: 16pt;
        line-height: 30pt;
        padding: 20px;
        padding-top: 0px;
        // background-color: rgba(255,255,255, 0.8);
        // border-radius: 8px;
        // border: 1px solid #f0f0f0;
        // box-shadow: -6px 0px 4px rgba(200,200,200,0.6)
    }

    @media ${breakpoint.laptop} {

        width: 100%;

        & p {
            margin: 0px;
            margin-top: 40px;
        }
    }

    @media ${breakpoint.phone} {

        width: 100%;

        & p {
            font-size: 14pt;
            line-height: 22pt;
            margin: 0px;
            margin-top: 40px;
            padding: 0px;
        }

    }


    `;



const FrameImage = styled.img`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    opacity: 0;

    &.visible {
        opacity: 1;
    }

    &.bordered {
        border: 1px solid #C0C0C0;
        border-radius: 5px;
        box-shadow: 5px 5px 5px #C0C0C0;
    }


    &.enter {
        opacity: 1;
        transition: opacity ${frameTimeStep * 0.75}ms linear;
        z-index: 100;
    }

    &.exit {
        opacity: 0;
        transition: opacity 1ms linear;
        transition-delay: ${frameTimeStep * 0.75}ms;
        z-index: -100;
    }


    &.freestanding {
        position: relative;
    }

`;




const DataSampleContainer = styled.div`
    position: absolute;
    bottom: 0px;
    width: 100%;
    display: flex;
    flex-direction: column;
    border-top: 1px solid #f0f0f0;
    z-index: 1000;
`;

const DataSampleRow = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    background-color: rgba(255,255,255, 0.5);
    padding: 5px;
    font-size: 10pt;

    @media ${breakpoint.phone} {

        font-size: 8pt;
        overflow: hidden;

    }

`;

const DataSampleRowLabel = styled.span`
    display: block;
    margin-right: 10px;

    font-family: Consolas,monaco,monospace;
    font-weight: bold;

    &:first-of-type {
        margin-left: 4px;
    }
`;

const DataSampleRowValue = styled.span`
    display: block;
    margin-right: 20px;
    font-family: Consolas,monaco,monospace;
    min-width: 100px;



`;

const musicAnimation = keyframes`

    from {
        margin-left: 0px;
    }

    to {
        margin-left: -1900px;
    }
`;

const ScoreSampleContainer = styled.div`
    position: absolute;
    bottom: 0px;
    height: 60px;
    width: 100%;
    box-shadow: 0px -3px 3px #f0f0f0;
    z-index: 1000;
    overflow: hidden;

    & img {
        margin-left: 0px;
        height: 60px;
        // animation: ${musicAnimation};
        // animation-duration: 20s;
        // animation-timing-function: linear;
        // animation-fill-mode: forwards;
        // animation-iteration-count: infinite;
        position: relative;
    }

    &&:before {
        position: absolute;
        left: 0px;
        top: 0px;
        width: 400px;
        height: 60px;
        content: "";
        background: linear-gradient(to left, rgba(255,255,255,0), rgba(255,255,255,1));
        z-index: 1000;
    }


    &&:after {
        position: absolute;
        right: 0px;
        top: 0px;
        width: 400px;
        height: 60px;
        content: "";
        background: linear-gradient(to right, rgba(255,255,255,0), rgba(255,255,255,1));
        z-index: 1000;
    }

    @media ${breakpoint.phone} {

        height: 40px;

        & img {
            height: 40px;
        
        }

        &&:before, &&:after {
            width: 100px;
            height: 40px;
        }

    }

`;


const wearableLabels = new Map([
    [0, "Glove-1"],
    [4, "Glove-2"],
    [8, "Glove-3"],
    [12, "Glove-4"],
    [16, "Foot-1"],
    [20, "Foot-2"],
    [124, "Foot-3"],
]);

const displaySampleData = (input) => {
    const [time, channel, values] = input;

    return <>
    <DataSampleRowLabel>Time</DataSampleRowLabel>
    <DataSampleRowValue>{Math.round((time - 1696344902687)/1000 * 1000)/1000}s</DataSampleRowValue>
    <DataSampleRowLabel>Wearable</DataSampleRowLabel>
    <DataSampleRowValue>{wearableLabels.get(channel)}</DataSampleRowValue>
    <DataSampleRowLabel>Signal</DataSampleRowLabel>
    <DataSampleRowValue>{values.join(" / ")}</DataSampleRowValue>
    </>;
    
}

const FilteredSampleSensorData = SampleSensorData.data.filter((d) => {
    const [time, channel, values] = d;
    return values.length > 0;
}).slice(0, 200);

const totalSampleDataCount = FilteredSampleSensorData.length;


const DataSample = ({currentDatumIndex}) => {

    let datumIndices;
    const displayCount = 4;
    if(currentDatumIndex + displayCount < totalSampleDataCount) {
        datumIndices = Array.from(new Array(displayCount), (x, i) => i + currentDatumIndex);
    } else {
        datumIndices = Array.from(new Array(displayCount), (x, i) => (i + currentDatumIndex) % totalSampleDataCount)
    }

    return <DataSampleContainer>
        {datumIndices.map(di => {
        const sampleDatum = FilteredSampleSensorData[di];

        return <DataSampleRow key={`data_sample_${di}`}>{displaySampleData(sampleDatum)}</DataSampleRow>
        })}
    </DataSampleContainer>;
}

const ScoreSample = ({imageIndex}) => {

    const imageOffset = -1 * (100 + imageIndex * 250);
    return <ScoreSampleContainer>
        <img style={{marginLeft: `${imageOffset}px`}} src={MusicScoreSnippet} />
    </ScoreSampleContainer>
}

const MovementImages = [
    Movement1,
    Movement2,
    Movement3,
    Movement4,
    Movement5,
    Movement6        
];

const VisualizationImages = [
    Visualization1,
    Visualization2,
    Visualization3,
    Visualization4,
    Visualization5,
    Visualization6,
    Visualization7,
    Visualization8        
];


const FrameAnimationSection = () => {

    const [imageIndex, setImageIndex] = useState(0);
    const [datumIndex, setDatumIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {

            setImageIndex(currentImageIndex => currentImageIndex + 1);

        }, 1500);
        return () => clearInterval(interval);
      }, []);

      useEffect(() => {

        const interval = setInterval(() => {

            setDatumIndex(currentDatumIndex => currentDatumIndex + 1);

        }, 500);
        return () => clearInterval(interval);
    
      }, []);

      

      let movementContent = <>{MovementImages.map((img, i) => {
            let className;
            if(i == (imageIndex % MovementImages.length)) {
                className = "enter";
            } else {
                className = "exit";
            }
            return <FrameImage key={`frame_movement_${i}`} className={`${className} bordered`} src={img} />;
        })}</>;


        let sensorsContent = <FrameImage className={"visible bordered"} src={Sensors1} />;

        let dataContent = <>{MovementImages.map((img, i) => {
            let className;
            if(i == (imageIndex % MovementImages.length)) {
                className = "enter";
            } else {
                className = "exit";
            }
            return <FrameImage key={`frame_data_${i}`} className={`${className} bordered`} src={img} />;


        })}
        <DataSample currentDatumIndex={datumIndex % FilteredSampleSensorData.length}/>
        </>;

        let visualizationContent = <>{VisualizationImages.map((img, i) => {
            let className;
            if(i == (imageIndex % VisualizationImages.length)) {
                className = "enter";
            } else {
                className = "exit";
            }
            return <FrameImage key={`frame_visualization_${i}`} className={className} src={img} />;
        })}</>;


        let interpretationContent = <FrameImage className={"visible bordered freestanding"} src={Interpretation1} />;

        let sonificationContent = <>
        {MovementImages.map((img, i) => {
            let className;
            let adjustedImageIndex = imageIndex % MovementImages.length;
            if(i == adjustedImageIndex) {
                className = "enter";
            } else {
                className = "exit";
            }

            return <FrameImage key={`frame_sonification_${i}`} className={`${className} bordered`} src={img} />;
        })}
        <ScoreSample imageIndex={imageIndex % MovementImages.length}/>
        </>;


      return <>
      <SectionContainer>
        <ImageOuterContainer>
            <ImageInnerContainer>
                {movementContent}
            </ImageInnerContainer>
        </ImageOuterContainer>
      <TextContainer>
            <p data-frame={LoopSectionName.Movement}>In its current form, the piece begins with a duet of dancers. In this duet, the dancers explore and attend to the continuous negotiations of shared movement, kinesthetically investigating the dynamic equilibria that are shaped and transformed through their physical interaction.
            </p>
        </TextContainer>
    </SectionContainer>
    <SectionContainer>
    <ImageOuterContainer>
            <ImageInnerContainer>
                {sensorsContent}
            </ImageInnerContainer>
        </ImageOuterContainer>
      <TextContainer>

            <p data-frame={LoopSectionName.Sensors}>The movement of the dancers is captured in real-time by custom-fabricated gloves and insoles worn by the dancers. Inside of these wearables, sensors are embedded that respond to changes in intensity and duration of pressure that occur throughout the shared movement. Each glove holds four embedded sensors, and each insole holds three, allowing for detection of shifts of pressure across hands and feet.</p>
        </TextContainer>
        </SectionContainer>
        <SectionContainer>
    <ImageOuterContainer>
            <ImageInnerContainer>
                {dataContent}
            </ImageInnerContainer>
        </ImageOuterContainer>
      <TextContainer>

    <p data-frame={LoopSectionName.Data}>These changes in pressure captured by the sensors are transformed into quantitative data, which are sent to a computer via transmitters. The data provide a signature of even small, nuanced movements between the dancers — that is, movement which may be invisible to the audience but that is kinesthetically significant.</p>
    </TextContainer>
    </SectionContainer>
    <SectionContainer>
    <ImageOuterContainer>
            <ImageInnerContainer className="bg-white">
                {visualizationContent}
            </ImageInnerContainer>
        </ImageOuterContainer>
      <TextContainer>
    <p data-frame={LoopSectionName.Visualization}>The data are then translated into a visualization that encodes the changes in pressure over time in a visual form. Through the visualization, the invisible subtleties of movement are rendered visible, increasing the resolution of what can be perceived about the physical negotiations occurring between the dancers in the duet.</p>
    </TextContainer>
    </SectionContainer>
    <SectionContainer>
    <ImageOuterContainer>
            <ImageInnerContainer className="freestanding">
                {interpretationContent}
            </ImageInnerContainer>
        </ImageOuterContainer>
      <TextContainer>

    <p data-frame={LoopSectionName.Interpretation}>The visualization is displayed on a computer screen, which is placed in front of musicians who interpret the encodings in the visualization as mappings of nuanced movement to a readable notation. The core material for the sound in <i>Proxies</i> comes from Tchaikovsky’s 5th Symphony, and the musicians use this material as the basis for their interpretation.
</p>
</TextContainer>
</SectionContainer>
<SectionContainer>
    <ImageOuterContainer>
            <ImageInnerContainer>
                {sonificationContent}
            </ImageInnerContainer>
        </ImageOuterContainer>
      <TextContainer>

    <p data-frame={LoopSectionName.Sonification}>The musicians then turn this process of interpretation into musical expression. As they respond to changes in the visualization, the musicians change the sound created through their instruments through dimensions like timbre, rhythm, volume, and instrumentation — in other words, sonifying the data made visible through the visualization.
</p>
        </TextContainer>
      </SectionContainer>
      </>

}

export default FrameAnimationSection;